import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

const selectors = {
    header: '.js-header:not(.is-initialized)',
    toggle: '.js-header-toggle',
    menu: '.js-header-menu',
    navTrigger: '.js-nav-trigger'
};

const classes = {
    open: 'is-open',
    visible: 'is-visible',
    hidden: 'is-hidden',
    locked: 'is-locked',
    reachedTop: 'has-reached-top'
};

let resizeTimeout;
let isMobile = window.matchMedia('(max-width: 1023px)').matches;

const getNavHeight = header => {
    clearTimeout(resizeTimeout);

    resizeTimeout = setTimeout(() => {
        const navHeight = header.clientHeight;
        document.documentElement.style.setProperty('--navH', `${navHeight}px`);
    }, 100);
}

const toggleHeader = (header, isOpen) => {
    header.classList.toggle(classes.open, isOpen);
    header.setAttribute('aria-expanded', isOpen);

    if (isMobile) {
        document.body.classList.toggle(classes.locked, isOpen);
    }

    requestAnimationFrame(() => {
        header.classList.toggle(classes.visible, isOpen);
    });
}

const showHideNav = header => {
    const navTrigger = document.querySelector(selectors.navTrigger) ?? document.body;

    gsap.to(header, {
        scrollTrigger: {
            trigger: navTrigger,
            start: '200px top',
            end: 'max',
            onEnter: () => {
                header.classList.remove(classes.reachedTop);
            },
            onUpdate: self => {
                if (self.direction === -1) {
                    header.classList.remove(classes.hidden);
                } else {
                    header.classList.add(classes.hidden);
                }
            },
            onLeaveBack: () => {
                header.classList.add(classes.hidden);
                header.classList.add(classes.reachedTop);
            },
        }
    });
}

const onResize = (header, menu) => {
    isMobile = window.matchMedia('(max-width: 1023px)').matches;
    getNavHeight(header);

    if (isMobile) {
        menu.role = 'dialog';
        menu.setAttribute('aria-modal', 'true');
    } else {
        menu.removeAttribute('aria-modal');
    }
}

const init = () => {
    const header = document.querySelector(selectors.header);
    
    if (!header) return;
    const menu = header.querySelector(selectors.menu);

    header.classList.add('is-initialized');

    onResize(header, menu);
    window.addEventListener('resize', () => {
        onResize(header, menu);
    });

    const toggles = header.querySelectorAll(selectors.toggle);

    toggles.forEach(toggle => {
        toggle.addEventListener('click', () => {
            const isOpen = header.matches(`.${classes.open}`);
            toggleHeader(header, !isOpen);
        });
    });

    window.addEventListener('keyup', e => {
        if (e.key === 'Escape') toggleHeader(header, false);
    });

    header.classList.add(classes.hidden);
    header.classList.add(classes.reachedTop);
    showHideNav(header);
};

const module = () => {
    init();
    document.addEventListener('domUpdated', init);
};

export default module;